import { Injector, Type } from '@angular/core';
import { createCustomElement } from '@angular/elements';

export function registerElements(component: Type<any>, tagName: string, injector: Injector): void {
  const el = createCustomElement(component, { injector });
  customElements.define(tagName, el);
}
